import "./Contact.module.css";
import YujuBranding from "@/reusable_sections/Header";
import PlanYourGathering from "./sections/PlanYourGathering";
import AboutMe from "./sections/AboutMe";
import ConsultasFrecuentes from "./sections/ConsultasFrecuentes";
import Consultation from "./sections/Consultation";
import BharatVidyaFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <YujuBranding />
      <PlanYourGathering />
      <AboutMe />
      <ConsultasFrecuentes />
      <Consultation />
      <BharatVidyaFooter />
    </div>;
}